export enum adminRecruitmentJobOfferTypes {
    FETCH_ADMIN_RECRUITMENT_JOB_OFFER_REQUEST = "FETCH_ADMIN_RECRUITMENT_JOB_OFFER_REQUEST",
    FETCH_ADMIN_RECRUITMENT_JOB_OFFER_SUCCESS = "FETCH_ADMIN_RECRUITMENT_JOB_OFFER_SUCCESS",
    FETCH_ADMIN_RECRUITMENT_JOB_OFFER_FAILURE = "FETCH_ADMIN_RECRUITMENT_JOB_OFFER_FAILURE",
  }